/**
 * A whitelist de nomes de `telemetry_sources.unsupported_charger_fields`.
 *
 * MODULO PROPRIO, e nao um bloco de `index.ts`, pela MESMA razao mecanica de
 * `campos.ts`: `carregadores.ts` precisa de `UnsupportedChargerField`, e
 * `index.ts` reexporta `carregadores.ts`. Importar do barril ali fecharia um
 * ciclo que o resolvedor recusa (`TS2305: has no exported member`). Tipo
 * compartilhado por dois modulos que o barril reexporta mora FORA do barril.
 *
 * ---------------------------------------------------------------------------
 * POR QUE UNIAO SEPARADA DE `UnsupportedField`, E NAO UMA LISTA SO
 *
 * A razao e MECANICA, nao estetica. `UnsupportedField` (`campos.ts`) e consumido
 * por `Record` EXAUSTIVOS nas seis telas de frota. Acrescentar `ocpp_messages` e
 * `remote_control` aquela uniao:
 *
 *   1. obrigaria cada `Record` de frota a declarar um balde para campo de
 *      CARREGADOR -- ruido que o compilador passaria a cobrar em seis telas que
 *      nao tem nada a ver com carregador;
 *   2. permitiria que `datalbus.unsupported_fields` contivesse legalmente
 *      `last_boot_at`, e que `vgpl.unsupported_charger_fields` contivesse
 *      `soc_pct` -- nonsense que nenhum `CHECK` de dominio unico pode recusar.
 *
 * O que E compartilhado entre as duas familias, e esta certo: `source`, `label`,
 * `display`, `writer`, `notes`. E a MESMA pergunta ("esta origem aparece?"), e as
 * linhas das duas familias NAO SE SOBREPOEM -- `datalbus` e fonte de veiculo,
 * `vgpl` e fonte de carregador, e a unica linha comum (`unknown`) tem os dois
 * arrays vazios. O principio do ADR 0003 §3.1 fica intacto: filtro de
 * visibilidade e vocabulario de impossibilidade saem da MESMA LINHA, com dois
 * vocabularios que nunca se encontram.
 * ---------------------------------------------------------------------------
 *
 * ESTA CONSTANTE E O `CHECK` DA MIGRATION 0027 SAO PROVADOS IGUAIS POR TESTE
 * (`apps/server/src/charger-source-whitelist.test.ts`), que le
 * `pg_get_constraintdef` do banco de verdade e compara com `Object.keys` daqui.
 * Sem a amarra, a divergencia e silenciosa nos DOIS sentidos:
 *
 *   - nome so no banco -> o TS nao conhece o campo, e a tela que deveria dizer
 *                         "nao fornecido por <fonte>" nao tem o literal para
 *                         comparar;
 *   - nome so no TS    -> o `INSERT` na tabela de fontes ABORTA em producao, no
 *                         meio do deploy, com `violates check constraint`.
 *
 * Os nomes sao os do BANCO (`snake_case`): eles viajam DENTRO do array e sao
 * comparados contra nomes de coluna.
 *
 * SEIS NOMES NAO SAO COLUNA DE `chargers`, e e deliberado -- o que a lista
 * descreve e "grandeza OU CAPACIDADE que a fonte nao entrega":
 *   `approval_decision`   nao existe decisao de aprovacao DO NXVOLT sobre os
 *                         equipamentos do VGPL; `nxv_vgpl.chargers` projeta
 *                         `'approved'::text` LITERAL;
 *   `connector_topology`  `nxv_vgpl.connectors` deriva o conjunto de conectores
 *                         de `vgpl.sessions`: conector que nunca teve sessao NAO
 *                         EXISTE na view -- o numero e o historico, nao a
 *                         topologia;
 *   `remote_control`      sem WebSocket OCPP com ESTE portal nao ha
 *                         RemoteStart/Stop/Reset/Unlock. Precedente: `gps_trail`
 *                         e `performance_samples` na 0026;
 *   `configuration`       Get/ChangeConfiguration, mesma razao;
 *   `ocpp_messages` / `meter_values` / `transactions` / `alerts` /
 *   `maintenance_orders`  sao RELACOES, e a pergunta "esta fonte alimenta esta
 *                         superficie?" e a mesma.
 *
 * ATENCAO AO VOCABULARIO, porque a lista NAO o distingue e a tela TEM de
 * distinguir: `ocpp_messages` e `meter_values` sao IMPOSSIBILIDADE PERMANENTE
 * (nao ha caminho -- os 38 falam com o servidor OCPP do VGPL), enquanto
 * `transactions`, `alerts` e `maintenance_orders` sao ESCOPO. Contagens na fonte
 * REMEDIDAS em 31/10/2026, e duas estavam erradas: `nxv_vgpl.transactions` =
 * **2.881** (a nota dizia 2.801), `nxv_vgpl.alerts` = **0** (a nota dizia 17) e
 * `nxv_vgpl.maintenance_orders` = **0 na fonte VGPL** (a nota dizia 73, e as 73
 * eram `public.maintenance_orders`, do proprio nxvolt, lidas de volta pela
 * auto-referencia daquela view). Zero HOJE nao vira impossibilidade -- ver
 * `CAPACIDADES_DE_ESCOPO`, no fim deste arquivo. A frase de impossibilidade diz
 * "NAO HA"; a de escopo diz "existem na fonte e NAO SAO SINCRONIZADAS NESTA
 * VERSAO do portal". Nunca uma no lugar da outra, e nunca as duas fundidas num
 * estado vazio generico -- ai o operador aprende a ignorar as duas.
 *
 * E DOIS NOMES ESTAO NA WHITELIST MAS **NAO** NA LISTA DA FONTE `vgpl`, o que os
 * torna o par que testa o classificador inteiro:
 *   `firmware`         vazio em 33/38 (Nansen) e PRESENTE no `T002` e nos 4 `sx`.
 *                      E AUSENCIA, nao impossibilidade -- igual ao `soc_pct`
 *                      14/16 da frota;
 *   `nominal_power_kw` 38/38 PRESENTE, mas com valor suspeito (22 em quase
 *                      todos, inclusive em 16 rotulados "DC Dual G3/G4"). Esta em
 *                      QUARENTENA: a sincronia nao propaga a coluna e o campo sai
 *                      `null`. Marca-lo aqui seria FALSO -- a fonte FORNECE o
 *                      campo --, e diria "nao fornecido por Portal VGPL" sobre um
 *                      valor que o Portal VGPL fornece. O que temos e AUSENCIA DE
 *                      VALOR CONFIAVEL, e a frase de ausencia ja existe e ja esta
 *                      certa: "Potencia nominal: nao informada".
 *
 * PROIBIDO, e registrado para impedir a "simplificacao": criar
 * `quarantined_fields` ou um quarto estado por causa de UM campo e de UMA
 * pergunta aberta. Se um dia houver tres campos em quarentena, ai e decisao
 * propria.
 */
const WHITELIST_DE_CAMPOS_DE_CARREGADOR = {
    last_boot_at: true,
    last_heartbeat_at: true,
    approval_decision: true,
    firmware: true,
    nominal_power_kw: true,
    connector_error_code: true,
    connector_info: true,
    connector_topology: true,
    ocpp_messages: true,
    meter_values: true,
    remote_control: true,
    configuration: true,
    transactions: true,
    alerts: true,
    maintenance_orders: true,
};
/**
 * A whitelist em runtime, na MESMA ORDEM do `CHECK` da migration 0027.
 *
 * A ordem entra no teste de igualdade. Nao e exigencia funcional (`<@` nao liga
 * para ordem): e o que torna a divergencia legivel no diff em vez de exigir um
 * `sort` mental.
 */
export const UNSUPPORTED_CHARGER_FIELDS = Object.freeze(Object.keys(WHITELIST_DE_CAMPOS_DE_CARREGADOR));
/**
 * ===========================================================================
 * A PARTIÇÃO DO VOCABULÁRIO. **ELA EXISTIA SÓ NA PROSA, E ESTE BLOCO A LEVA AO
 * DADO.**
 * ===========================================================================
 *
 * O cabeçalho deste arquivo já dizia, por extenso, que `ocpp_messages` e
 * `meter_values` são IMPOSSIBILIDADE PERMANENTE enquanto `transactions`,
 * `alerts` e `maintenance_orders` são ESCOPO — *"nunca uma no lugar da outra, e
 * nunca as duas fundidas num estado vazio genérico"*. E a revisão cruzada
 * mediu o problema: **aquilo era um parágrafo.** Nada no tipo, nada no banco e
 * nada em teste separava os dois conjuntos, e o `CHECK` de domínio não pode
 * distinguir — para ele os quinze nomes são strings de uma lista.
 *
 * A CONSEQUÊNCIA ERA CONCRETA, não teórica: `impossibilidadeDeCarregador()`
 * tinha um fallback — `'Este recurso não existe para a fonte configurada.'` —
 * e `FRASES_DE_IMPOSSIBILIDADE` deliberadamente NÃO listava as três de escopo.
 * Logo, uma chamada com `'transactions'` não era recusada: ela caía no fallback
 * e devolvia **"não existe"** sobre 2.881 sessões que EXISTEM na fonte. A
 * omissão, que era a defesa, era também o buraco.
 *
 * AGORA SÃO TRÊS UNIÕES DISJUNTAS, e um teste prova que elas PARTICIONAM a
 * whitelist (total e sem interseção). Acrescentar um nome ao `CHECK` sem
 * classificá-lo quebra a suíte; chamar a função de impossibilidade com um nome
 * de escopo **não compila**.
 *
 * ---------------------------------------------------------------------------
 * POR QUE TRÊS E NÃO DUAS: ao classificar, apareceu um nome que não é nenhuma
 * das duas. `last_heartbeat_at` está em `vgpl.unsupported_charger_fields`, mas
 * o efeito dele NÃO é uma frase de estado vazio — é
 * `charger_visible.contact_means` / `connected_means`, que DECLARAM o
 * significado do carimbo que CHEGA. Dizer "não fornecido" sobre uma coluna que
 * vem preenchida seria a mesma falsidade, com o sinal trocado. É a mesma forma
 * de `telemetry_push` em `campos.ts`.
 *
 * E DOIS NOMES NÃO ENTRAM EM NENHUMA DAS TRÊS: `firmware` e `nominal_power_kw`.
 * Eles estão na whitelist (são nomes VÁLIDOS) e **não estão na lista da fonte
 * `vgpl`** — `firmware` é AUSÊNCIA (vazio em 33/38, presente no T002 e nos 4
 * `sx`) e `nominal_power_kw` é QUARENTENA (38/38 presente, com valor suspeito).
 * Marcá-los seria FALSO. Eles existem aqui para o dia em que ALGUMA fonte
 * declarar que não os entrega, e por isso a partição os põe num quarto balde
 * explícito em vez de forçá-los num dos três.
 */
/** IMPOSSIBILIDADE PERMANENTE: a frase diz *"não há"*, porque não existe caminho. */
export const CAPACIDADES_DE_IMPOSSIBILIDADE = [
    'last_boot_at',
    'approval_decision',
    'connector_error_code',
    'connector_info',
    'connector_topology',
    'ocpp_messages',
    'meter_values',
    'remote_control',
    'configuration',
];
/**
 * ESCOPO: o dado EXISTE na fonte e não é sincronizado NESTA VERSÃO do portal.
 *
 * A frase diz *"existem na fonte e não são sincronizadas nesta versão do
 * portal"*. **Jamais "não há"**, e jamais um estado vazio genérico: aí o
 * operador aprende a ignorar os dois.
 *
 * Medido na fonte VGPL em 31/10/2026, e os três números foram CORRIGIDOS nesta
 * revisão porque dois estavam errados e o terceiro media outra coisa:
 *   `nxv_vgpl.transactions`        **2.881** (a nota antiga dizia 2.801)
 *   `nxv_vgpl.alerts`              **0**     (a nota antiga dizia 17; a view só
 *                                            produz linha para `status` em
 *                                            'fault'/'offline', e não há nenhum)
 *   `nxv_vgpl.maintenance_orders`  **0 na fonte VGPL.** A nota antiga dizia 73,
 *                                  e as 73 eram `public.maintenance_orders` —
 *                                  a tabela do NXVOLT, lida de volta pela ponte
 *                                  por causa de um `FROM maintenance_orders`
 *                                  NÃO QUALIFICADO na segunda perna do
 *                                  `UNION ALL` daquela view.
 *
 * MECANISMO DAS 73, e a primeira versão desta nota o atribuía errado ao
 * `search_path` do papel da aplicação: ele é **`public`** desde 30/09/2026
 * (medido em `pg_roles.rolconfig`, ADR 0004 §1.1). A resolução do nome aconteceu
 * **no `CREATE VIEW`**, contra o `search_path` da sessão de quem criou a view, e
 * ficou guardada **por OID** — o Postgres não re-resolve nome dentro de view já
 * criada. O número 73 está certo; a causa é essa.
 *
 * `alerts` e `maintenance_orders` com ZERO na fonte continuam aqui, e a razão é
 * que o balde descreve a RELAÇÃO ENTRE O PORTAL E A FONTE, não a contagem de
 * hoje: a capacidade de sincronizá-los existe e foi deixada fora DESTA versão
 * (decisão B1 = opção A do PM). Um alerta que apareça no VGPL amanhã é dado que
 * existe e não chega — que é a definição de escopo. Movê-los para
 * impossibilidade porque hoje estão em zero seria declarar permanente uma
 * decisão de versão.
 */
export const CAPACIDADES_DE_ESCOPO = ['transactions', 'alerts', 'maintenance_orders'];
/**
 * SIGNIFICADO DECLARADO: o campo CHEGA PREENCHIDO e mede outra grandeza.
 *
 * Não produz frase de estado vazio nenhuma. Produz
 * `charger_visible.contact_means` / `connected_means`. Ver o bloco da partição.
 */
export const CAPACIDADES_DE_SIGNIFICADO = ['last_heartbeat_at'];
/**
 * NOMES VÁLIDOS QUE NENHUMA FONTE DECLARA HOJE — e não podem ser declarados.
 *
 * `firmware` é AUSÊNCIA e `nominal_power_kw` é QUARENTENA. As duas frases certas
 * já existem e são de ausência ("não informado", "Potência nominal: não
 * informada"). Marcá-los em `unsupported_charger_fields` diria "não fornecido
 * por Portal VGPL" sobre campos que o Portal VGPL FORNECE.
 */
export const CAPACIDADES_SEM_BALDE = ['firmware', 'nominal_power_kw'];
/** `true` quando o campo é de ESCOPO — e aí a frase de "não há" é PROIBIDA. */
export function ehCapacidadeDeEscopo(campo) {
    return CAPACIDADES_DE_ESCOPO.includes(campo);
}
